import { atomFamily, DefaultValue } from "recoil";

export interface TableStateData {
  sortField?: string;
  sortDirection?: "asc" | "desc" | string;
  page?: number;
  pageSize?: number;
  searchField?: string;
  searchText?: string;
  searched?: boolean;
  filterField?: string;
  filterSelected?: string[];
  filterValues?: string[];
  filterShowForm?: boolean;
  showSearchForm?: boolean;
  selectedRowKey?: string;
  selectedRowValue?: string;
  filters?: Record<string, unknown>;
  [key: string]: unknown;
}

const getStorageKey = (tableId: string) => `oc_table_${tableId}`;

const tableStateEffect =
  (tableId: string) =>
  ({ setSelf, onSet }: { setSelf: (value: TableStateData) => void; onSet: (callback: (newValue: TableStateData | DefaultValue) => void) => void }) => {
    const storageKey = getStorageKey(tableId);

    // Load from sessionStorage on init
    const savedValue = sessionStorage.getItem(storageKey);
    if (savedValue) {
      try {
        setSelf(JSON.parse(savedValue));
      } catch {
        // Ignore parse errors
      }
    }

    // Save to sessionStorage on change
    onSet((newValue) => {
      if (newValue instanceof DefaultValue) {
        sessionStorage.removeItem(storageKey);
      } else {
        sessionStorage.setItem(storageKey, JSON.stringify(newValue));
      }
    });
  };

export const ocTableState = atomFamily<TableStateData, string>({
  key: "ocTableState",
  default: {},
  effects: (tableId) => [tableStateEffect(tableId)],
});
